import React from 'react';

const PhoneFormatted = ({ children }) => <span>{children}</span>;

export default PhoneFormatted;
